import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Dashboard from "../../components/dashboard/Dashboard";

const DashboardPage = () => {
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              <Navbar content="Dashboard" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <Dashboard />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardPage;
